import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import {
  FilterRes,
} from '../../../../shared/functions/shared-functions';
import { CoreService } from '../../../../services/core.service';
import { UntilDestroy } from '@ngneat/until-destroy';

declare var $: any;

@UntilDestroy()
@Component({
  selector: 'app-show-last-training-center-receipts',
  templateUrl: './show-last-training-center-receipts.component.html',
  styleUrls: ['./show-last-training-center-receipts.component.scss']
})
export class ShowLastTrainingCenterReceiptsComponent implements OnInit {
  receipts: any = [];
  dataSource = new MatTableDataSource<any>();
  columns = [];
  selectedRow;
  loading = true;

  constructor(
    private coreService: CoreService,
    public dialogRef: MatDialogRef<ShowLastTrainingCenterReceiptsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  ngOnInit(): void {
    this.getDocument();
    this.columns = ['image', 'choose'];
  }

  getDocument() {
    this.coreService
      .getRequest(
        `Oneincome/api/Document/GetAllDocumentForNullCasherId?actioncode=PaymentReceipt&persondataid=${this.data?.receiptData?.persondata?.id}&SystemActionCode=${this.data?.receiptData?.systemActionCode}&NeededSystemActionCode=Traninng`
        , {}, true, false)
      .subscribe(
        (res) => {
          this.loading = false;
          this.receipts = FilterRes(res);
          this.dataSource = new MatTableDataSource<any>(this.receipts);
        },
        (error) => {
          this.loading = false;
        },
      );
  }

  showImage(url) {
    window.open(url, '_blank');
  }

  selectRow(e, row) {
    console.log('e', e);
    // this.selectedRow = row;
    if (e.checked) {
      this.selectedRow = row;
    } else {
      this.selectedRow = void 0;
    }
  }

  choose() {
    this.dialogRef.close({ selectedRow: this.selectedRow });
  }
}
